<script lang="ts" generics="ROW">
    import {getGridContext} from 'shared/ui-widgets/grid/grid.context';
    import type {Header} from '@tanstack/svelte-table';
    import {isLastColumnInMainColumnGroup} from 'shared/ui-widgets/grid/utils';

    export let header: Header<ROW, unknown>;

    const {settings: {columnPinningEnabled, mainGroupsDivided, columnResizingEnabled, colorAccented, condensed}} = getGridContext();

    $: isColumnGroupBorder = mainGroupsDivided && isLastColumnInMainColumnGroup(header.column);
    $: pinnedLeft = columnPinningEnabled && header.column.getIsPinned() === 'left';
    $: leftOffset = (columnPinningEnabled || columnResizingEnabled) ? `${header.getStart('left')}px` : '0px';
</script>

<div role="columnheader"
     class="kp-generic-grid-footer-header-cell"
     class:condensed
     class:column-group-border={isColumnGroupBorder}
     class:color-accented={colorAccented}
     class:pinned-left={pinnedLeft}
     style:width="{header.getSize()}px"
     style:--left-offset="{leftOffset}">
    <slot/>
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";
    @default-border-width: 1px;

    .kp-generic-grid-footer-header-cell {
        position: relative;
        flex: none; // row is flexbox, cell is fixed size

        line-height: @line-height-base;
        padding: @table-condensed-cell-padding;

        white-space: nowrap;
        align-content: center;
        font-weight: bold;
        text-align: center;
        background-color: #ffffff;

        border-bottom: @default-border-width solid #CCC;
        border-right: var(--col-border-width, @default-border-width) solid #CCC;

        &:empty {
            padding: 0;
            display: none;
        }

        &.condensed {
            padding: 3px;
            font-size: 12px;

            &:empty {
                padding: 0;
            }
        }

        //&.color-accented {
        //    color: var(--table-header-accent-color);
        //    border-top: 2px solid var(--table-header-accent-color);
        //}

        &.column-group-border {
            --col-border-width: 2px;
        }

        &.pinned-left {
            position: sticky;
            left: var(--left-offset, 0px);
            z-index: var(--z-index, 5);
        }
    }
</style>